import { render, staticRenderFns } from "./ClueHistory.vue?vue&type=template&id=9aa592a8&scoped=true"
import script from "./ClueHistory.vue?vue&type=script&lang=js"
export * from "./ClueHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa592a8",
  null
  
)

export default component.exports